import stickyMap, { destroyStickyMap } from './stick-map';
import locationGoogleMaps from './google-maps';

/* eslint no-param-reassign: "error" */
function toggleClass(el, className) {
  if (el.classList) {
    el.classList.toggle(className);
    destroyStickyMap();
    stickyMap();
  }

  if (el.classList.contains(className)) locationGoogleMaps();
}

const eventHandler = () => {
  const listMain = document.querySelector('.js-location-list-container');
  const switchInput = document.querySelector('#toggleMap');
  if (switchInput)
    switchInput.addEventListener('click', () => {
      toggleClass(listMain, 'isMapOpen');
    });
};

const toggleMap = async () => {
  eventHandler();

  const list = document.querySelector('.js-location-list-container');

  if(list && list.classList.contains('js-show-map-onload')) {
    toggleClass(list, 'isMapOpen');
  }
};

export default toggleMap;
